import React from "react"
import PropTypes from "prop-types"
import TextField from "material-ui/TextField"
import RaisedButton from "material-ui/RaisedButton"
import StateSelectField from "./StateSelectField"

let saveTimeout

const propTypes = {
    onValueChange: PropTypes.func,
    value: PropTypes.string,
    hintValue: PropTypes.string,
    type: PropTypes.string,
    floatingLabelText: PropTypes.string,
    style: PropTypes.object,
    innerStyle: PropTypes.object
}

export default class VerifyField extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            confirm: false,
            confirmQuestion: ""
        }

        this.handleStateChange = this.handleStateChange.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.onFocus = this.onFocus.bind(this)
        this.onYesClick = this.onYesClick.bind(this)
        this.onNoClick = this.onNoClick.bind(this)
    }

    onNoClick() {
        this.setState(
            {
                confirm: false,
                value: this.getEmptyValue()
            },
            () => {
                this.refs.verifyFieldRef.input.focus()
            }
        )
    }

    onYesClick() {
        this.setState(
            {
                confirm: false
            },
            () => {
                this.props.onValueChange(this.state.value)
                this.refs.verifyFieldRef.input.focus()
            }
        )
    }

    onFocus() {
        this.refs.verifyFieldRef.input.select()
    }

    componentWillReceiveProps(nextProps) {
        //If we have an actual value, we don't need to confirm the hint value.
        if (nextProps.value) {
            this.setState({
                confirm: false,
                value: nextProps.value
            })
        } else if (nextProps.hintValue) {
            const confirmQuestion = nextProps.confirmQuestion.format(nextProps.hintValue)
            this.setState({
                confirm: true,
                value: nextProps.hintValue,
                confirmQuestion: confirmQuestion
            })
        } else {
            this.setState({
                confirm: false,
                value: ""
            })
        }
    }

    handleChange(event) {
        const _this = this
        this.setState(
            {
                value: event.target.value
            },
            () => {
                if (saveTimeout) {
                    clearTimeout(saveTimeout)
                }

                saveTimeout = setTimeout(function() {
                    _this.props.onValueChange(_this.state.value)
                }, 750)
            }
        )
    }

    handleStateChange(value) {
        const _this = this
        this.setState(
            {
                value: value
            },
            () => {
                if (saveTimeout) {
                    clearTimeout(saveTimeout)
                }

                saveTimeout = setTimeout(function() {
                    _this.props.onValueChange(_this.state.value)
                }, 750)
            }
        )
    }

    getEmptyValue() {
        if (this.props.type === "StateSelectField") {
            return "AL"
        } else {
            return ""
        }
    }

    getField() {
        if (this.props.type === "StateSelectField") {
            return <StateSelectField id="state" value={this.state.value} onValueChange={this.handleStateChange} />
        } else {
            return (
                <TextField
                    id="textfield"
                    floatingLabelText={this.props.floatingLabelText}
                    value={this.state.value}
                    style={{ width: "100%" }}
                    onChange={this.handleChange}
                    onFocus={this.onFocus}
                    ref="verifyFieldRef"
                    tabindex="-1"
                />
            )
        }
    }

    render() {
        return (
            <div className="VerifyField" style={this.props.style} id="div-container">
                {!this.state.confirm ? (
                    <div> {this.getField()} </div>
                ) : (
                    <div>
                        <div style={this.props.innerStyle}>
                            <div
                                style={{ fontSize: 16, marginBottom: 5 }}
                                dangerouslySetInnerHTML={{
                                    __html: this.state.confirmQuestion
                                }}
                            />
                            <RaisedButton label="Yes" onClick={this.onYesClick} secondary={true} />
                            <RaisedButton label="No" secondary={true} onClick={this.onNoClick} style={{ marginLeft: 20 }} />
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

VerifyField.propTypes = propTypes
